import {PropsWithChildren, useEffect} from 'react';
import {useOktaAuth} from '@okta/okta-react';

import {setTokenAndAuthorized} from 'core/stores/auth';
import {EnnablLogger} from 'utils/ennabl';

export const OktaAuthProviderInternal = ({children}: PropsWithChildren) => {
  const {oktaAuth, authState} = useOktaAuth();
  const token = authState?.idToken?.idToken;

  useEffect(() => {
    if (token) {
      setTokenAndAuthorized(token);
    }
  }, [token]);

  useEffect(() => {
    (async () => {
      const state = await oktaAuth.authStateManager.updateAuthState();

      EnnablLogger.log(['OktaAuthProviderInternal', 'state'], {
        state,
        oktaAuth,
      });

      if (!state.isAuthenticated) {
        EnnablLogger.log(['OktaAuthProviderInternal', 'no authState or not authenticated, redirecting to login'], {
          oktaAuth,
        });

        await oktaAuth.signInWithRedirect({
          scopes: ['openid', 'profile', 'email', 'offline_access'],
          originalUri: window.location.origin + window.location.pathname,
        });
      }
    })();
  }, [oktaAuth]);

  return children;
};
